<template>
<div class="container bg-white" >
	<div  style="margin-top: 60px;padding-top:10px;">
		<div class="d-flex justify-content-between align-items-center">
			<h2 v-if="bid && 'Job' in bid && bid.Job" style="margin-bottom: 0">Project #{{ bid.Job.job_num }}</h2>
			<div>
				<button class="btn btn-light" v-on:click="refreshBid"> 
					<i class="fa fa-redo"></i>
					Update
				</button>
			</div>
		</div>

		<project-bid-summary
			:bid-prop="bid"
			:hide-spec-number="true"
			:hide-price-adjustment="true"
			:hide-markup="true"
			:hide-new-tab-link="true">
		</project-bid-summary>
	</div>
</div>
</template>
<script>
import ProjectBidSummary from "@/pages/project/project_tabs/bidding/components/ProjectBidSummary"

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "ProjectBidSummaryFullscreen",
	components: {
		ProjectBidSummary
	},
	mixins: [ProjectBidMixins],
	data() {
		return {
			bid: null,
		}
	},
	methods: {
		refreshBid() {
			let vm = this
			this.spinner(true)

			this.fetchBid(this.$route.params.bidSlug).then(response => {
				vm.spinner(false)
			})
		}
	},
	created() {
		this.fetchBid(this.$route.params.bidSlug)

		this.$store.printMode = true
	}
}	

</script>